import React from 'react';
import MainShell from '../components/MainShell';

const PlaceholderPage: React.FC<{title:string,active:string}> = ({title,active})=>{
  return (
    <MainShell active={active}>
      <div className="flex items-center justify-center h-full w-full text-foreground">
        <h1 className="text-2xl font-semibold">{title} (Coming soon)</h1>
      </div>
    </MainShell>
  );
};

export default PlaceholderPage; 